<template>
  <div :style="listHeight">
    <!-- <div :style="listHeight">
      <el-scrollbar style="height:100%;">
        <div class="Details">
          <el-row v-for="item in RecordList" :key="item.ID">
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-row>
                  <el-col :span="24">
                    <div class="title">{{item.NAME}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="tagtitle">创建人</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="tagtitle">{{item.CREATEUSERNAME}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="tagtitle">创建时间</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="tagtitle">{{item.CREATETIME |timeFormater}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="tagtitle">记录编号</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="tagtitle">{{item.INSTANCE}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="tagtitle">任务编号</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="tagtitle">{{task.INSTANCE}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="tagtitle">{{typeName(item)}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="abstract" v-html="item.INFO"></div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-scrollbar>
    </div> -->
    <el-scrollbar style="height: calc(100% - 30px);">
      <RecordCollection
        v-loading="loading"
        :outSource="RecordList"
        style="margin:5px"
      ></RecordCollection>
    </el-scrollbar>
    <el-row>
      <div class="button-div">
        <el-button
          type="primary"
          size="small"
          @click="onShowDialog"
          icon="el-icon-circle-plus-outline"
          >新增工作记录</el-button
        >
      </div>
    </el-row>
    <side-tags-record-dialog
      ref="SideTagsRecordDialog"
    ></side-tags-record-dialog>
  </div>
</template>

<script>
import { getToken } from "@/util/auth";
import RecordCollection from "../Record/RecordCollection.vue";
// import SideTagsRecordDialog from "./SideTagsRecordDialog.vue";
// import Editor from "@/components/common/editor";
import {
  GetRecordInfoByMainId,
  AddOrUpdateRecordInfo
} from "@/api/modules/basicData/task";
export default {
  components: {
    RecordCollection
    // SideTagsRecordDialog
  },
  data() {
    return {
      isClear: false,
      loading: false,
      RecordList: {},
      dialogFormVisible: false,
      checked: true,
      formLabelWidth: "120px",
      TaskInstance: "",
      BelongUser: "",
      WorkTitle: "",
      WorkContent: "",
      IsOpen: false,
      TaskName: "",
      RECORDTYPE: "0"
    };
  },
  created() {
    let a = $(window).height();
    this.listHeight = "height:" + (a - 140) + "px;";
  },
  methods: {
    initalTask: function() {
      if (!this.task || this.tabIndex !== "5") return;
      this.loading = true;
      GetRecordInfoByMainId(this.task.ID, 0).then(source => {
        if (!source) {
          this.loading = false;
          return;
        }
        this.RecordList = source;
        this.loading = false;
      });
    },
    onShowDialog: function() {
      console.log("onShowDialog");
      this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
      this.$refs.SideTagsRecordDialog.addRecordRelation(
        this.task.ID,
        this.task.TASKNAME,
        0,
        this.task.INSTANCE
      );
    }
    // typeName: function(item) {
    //   const openName = item.ISOPEN ? "[公开]" : "[私人]";
    //   const typeName = item.RECORDTYPE === 0 ? "[个人]" : "[会议]";
    //   return typeName + openName;
    // }
  },
  computed: {
    task: function() {
      return this.$store.state.task.curTask;
    },
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    }
  }
};
</script>

<style scoped="true">
.Details .el-row {
  /* margin-bottom: 20px; */
  padding: 20px 20px 0 20px;
}
.grid-content .el-row {
  padding: 5px 20px 0 20px;
}
.el-col {
  border-radius: 4px;
  text-align: left;
}
.button .el-button {
  background: #ecf5ff;
  color: #0099ff;
}
.button {
  padding: 0px 0 10px 20px;
  float: left;
}
.bg-purple-dark {
  background: white;
  margin-bottom: 10px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.Details {
  background-color: #f3f3f3;
  min-height: 500px;
}
.title {
  text-align: left;
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #0099ff;
}
.abstract {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #f56c6c;
}
.tagtitle {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #858585;
}
.button-div {
  margin-left: 20px;
}
</style>
